import RiveWasm from './rive-wasm';

export default RiveWasm;
